export default ($) => {
  const $window = $(window)

  $(() => {

    const $breadcrumbList = $('.breadcrumbList')

    if ($breadcrumbList.length && !deviceInfo.css.position.sticky) {
      const $breadcrumbList__home = $breadcrumbList.find('.breadcrumbList__item').eq(0)

      $breadcrumbList.on('touchmove', () => {
        $breadcrumbList__home.css({
          'left': ($breadcrumbList.scrollLeft() - 20) + 'px'
        }).addClass('touchmove')
      })
    }

  })

}